module.exports = __webpack_public_path__ + "static/media/more.25a91df8.svg";